module.exports = __webpack_public_path__ + "img/giftcard-background-desktop.2bb77cc.png";